import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';

export const fileKey = ['feasibilityPlant'];

const useFeasibilityPlant = () => useQuery({
  queryKey: fileKey,
  queryFn: () => agent.getClient()('file-data/calc?dataType=feasibility_plant').then(
    (response) => response.data,
  ),
});

export default useFeasibilityPlant;
